/* =========================================================
   Komochi v2 — テーマJS
   カートドロワー / AJAXカート / 予測検索 / バリアント切替 /
   数量ステッパー / スライドショー / モバイルメニュー
   ========================================================= */
(function () {
  'use strict';

  var routes = window.themeRoutes || {};

  /* ---------- ユーティリティ ---------- */
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function formatResultItem(item) {
    var img = item.image
      ? '<img src="' + item.image + '&width=96" class="h-12 w-12 rounded-lg border border-zinc-100 object-cover" alt="" loading="lazy">'
      : '<div class="h-12 w-12 rounded-lg bg-zinc-100"></div>';
    return (
      '<a href="' + item.url + '" class="flex items-center gap-3 px-3.5 py-2.5 hover:bg-zinc-50">' +
      img +
      '<span class="min-w-0"><span class="block truncate text-sm font-bold">' + item.title + '</span>' +
      (item.price ? '<span class="text-xs text-zinc-500">' + item.price + '</span>' : '') +
      '</span></a>'
    );
  }

  /* ---------- カートドロワー ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.add('hidden');
    document.body.style.overflow = '';
  }

  function refreshDrawer() {
    return fetch((routes.root || '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html || !drawer) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var current = drawer.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) current.replaceWith(fresh);
        bindDrawerEvents();
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
      });
  }

  function bindDrawerEvents() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    drawer.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.dataset.line, 10);
        var mode = btn.dataset.qtyChange;
        var qtyEl = btn.closest('.flex.items-center') ?
          btn.parentElement.querySelector('span') : null;
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var quantity = mode === 'remove' ? 0 : Math.max(0, current + parseInt(mode, 10));
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        }).then(function () {
          refreshDrawer();
          updateCartCount();
        });
      });
    });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      refreshDrawer().then(openDrawer);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeMenu();
    }
  });

  bindDrawerEvents();

  /* ---------- AJAXカート追加 ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      var text = form.querySelector('[data-add-to-cart-text]');
      var original = text ? text.textContent : '';
      if (btn) btn.disabled = true;

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () {
          updateCartCount();
          return refreshDrawer();
        })
        .then(openDrawer)
        .catch(function (err) {
          if (text) {
            text.textContent = (err && err.description) || 'エラーが発生しました';
            setTimeout(function () { text.textContent = original; }, 3000);
          }
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    });
  });

  /* ---------- バリアント切替 ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var select = root.querySelector('[data-variant-select]');
    var jsonEl = root.querySelector('[data-variant-json]');
    if (!select || !jsonEl) return;

    var variants = JSON.parse(jsonEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var mainImage = root.querySelector('[data-main-image]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addText = root.querySelector('[data-add-to-cart-text]');

    select.addEventListener('change', function () {
      var variant = variants.find(function (v) { return String(v.id) === select.value; });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        var note = priceEl.querySelector('span');
        priceEl.textContent = variant.price;
        if (note) priceEl.appendChild(note);
      }
      if (mainImage && variant.image) {
        mainImage.src = variant.image;
        mainImage.removeAttribute('srcset');
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) {
        addText.textContent = variant.available
          ? addText.dataset.labelAdd || 'カートに入れる'
          : addText.dataset.labelSoldout || '売り切れ';
      }
    });
  });

  /* ---------- 画像ギャラリー（サムネイル切替） ---------- */
  /* バリアントの有無に関わらず動作させるため、バリアント処理から独立させる */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var mainImage = root.querySelector('[data-main-image]');
    if (!mainImage) return;
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.dataset.full;
        mainImage.removeAttribute('srcset');
      });
    });
  });

  /* ---------- 数量ステッパー ---------- */
  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.parentElement;
      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      input.value = btn.hasAttribute('data-qty-plus') ? v + 1 : Math.max(min, v - 1);
    });
  });

  /* ---------- 予測検索 ---------- */
  document.querySelectorAll('[data-search-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('[data-predictive-search]');
    var results = wrapper.querySelector('[data-search-results]');
    if (!input || !results) return;

    var search = debounce(function (q) {
      if (q.length < 2) {
        results.classList.add('hidden');
        return;
      }
      var url = (routes.predictiveSearch || '/search/suggest') +
        '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (products.length === 0) {
            results.classList.add('hidden');
            return;
          }
          results.innerHTML = products.map(function (p) {
            return formatResultItem({
              url: p.url,
              title: p.title,
              price: p.price ? '¥' + Number(p.price).toLocaleString() : '',
              image: p.featured_image && p.featured_image.url ? p.featured_image.url : null
            });
          }).join('') +
          '<a href="' + (routes.search || '/search') + '?q=' + encodeURIComponent(q) +
          '" class="block border-t border-zinc-100 px-3.5 py-2.5 text-center text-sm font-bold text-primary hover:bg-zinc-50">すべての結果を見る</a>';
          results.classList.remove('hidden');
        });
    }, 250);

    input.addEventListener('input', function () { search(input.value.trim()); });
    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) results.classList.add('hidden');
    });
  });

  /* ---------- モバイルメニュー ---------- */
  var menuDrawer = document.querySelector('[data-menu-drawer]');

  function closeMenu() {
    if (!menuDrawer) return;
    menuDrawer.classList.add('hidden');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!menuDrawer) return;
      menuDrawer.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    });
  });

  if (menuDrawer) {
    menuDrawer.querySelectorAll('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', closeMenu);
    });
  }

  /* ---------- スライドショー ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-slides]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var loop = slides.length > 1;

    function cellWidth() {
      var cell = slides[0] || track.firstElementChild;
      if (!cell) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return cell.getBoundingClientRect().width + gap;
    }

    function centerOn(el, smooth) {
      if (!el) return;
      var left = el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
      track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
    }

    var lastClone, firstClone;
    if (loop) {
      // 無限ループ用に前後へクローンを差し込み、両端でも隣のスライドが見切れて表示される
      lastClone = slides[slides.length - 1].cloneNode(true);
      firstClone = slides[0].cloneNode(true);
      lastClone.setAttribute('data-clone', '');
      firstClone.setAttribute('data-clone', '');
      track.insertBefore(lastClone, slides[0]);
      track.appendChild(firstClone);
      // 実体の1枚目に初期位置を合わせる（左にlastCloneが見切れる）
      requestAnimationFrame(function () { centerOn(slides[0], false); });

      // スクロールが落ち着いたタイミングでクローン上にいれば実体へ瞬間移動
      var settle;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var lcLeft = lastClone.offsetLeft - (track.clientWidth - lastClone.offsetWidth) / 2;
          var fcLeft = firstClone.offsetLeft - (track.clientWidth - firstClone.offsetWidth) / 2;
          if (Math.abs(track.scrollLeft - lcLeft) < 6) {
            centerOn(slides[slides.length - 1], false);
          } else if (Math.abs(track.scrollLeft - fcLeft) < 6) {
            centerOn(slides[0], false);
          }
        }, 160);
      });
    }

    function go(dir) {
      track.scrollBy({ left: dir * cellWidth(), behavior: 'smooth' });
    }

    var prev = root.querySelector('[data-slide-prev]');
    var next = root.querySelector('[data-slide-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var interval = parseInt(root.dataset.autoplay, 10);
    if (interval) {
      var timer = setInterval(function () { go(1); }, interval);
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', function () {
        timer = setInterval(function () { go(1); }, interval);
      });
    }
  });

  /* ---------- 販売者情報・特定商取引法表示（Puppet Vendors API） ---------- */
  function sellerProfileValue(profile, keys) {
    for (var i = 0; i < keys.length; i += 1) {
      var value = profile[keys[i]];
      if (value !== undefined && value !== null && String(value).trim()) return String(value).trim();
    }
    return '';
  }

  function sellerProfileAddress(profile) {
    var address = profile.businessAddress || profile['Business Address'] || {};
    if (typeof address === 'string') return address.trim();
    var parts = [
      address.postalCode || address.zip || profile['Postal Code'],
      address.country || profile.country,
      address.state || address.province || profile.state,
      address.city || profile.city,
      address.address1 || address.address || profile['Address 1'],
      address.address2 || profile['Address 2']
    ];
    return parts.filter(function (part) { return part && String(part).trim(); }).map(function (part) { return String(part).trim(); }).join(' ');
  }

  function appendSellerLegalRow(list, label, value) {
    if (!value) return false;
    var row = document.createElement('div');
    row.className = 'grid gap-1 py-3 sm:grid-cols-[11rem_1fr] sm:gap-4';
    var term = document.createElement('dt');
    term.className = 'font-bold text-zinc-700';
    term.textContent = label;
    var description = document.createElement('dd');
    description.textContent = value;
    row.appendChild(term);
    row.appendChild(description);
    list.appendChild(row);
    return true;
  }

  document.querySelectorAll('[data-seller-legal-info]').forEach(function (el) {
    var vendor = (el.dataset.vendor || '').trim();
    var shop = el.dataset.shop;
    if (!vendor || !shop) return;

    var endpoint =
      'https://app.puppetvendors.com/webhooks/vendor/profiles?shop=' +
      encodeURIComponent(shop) +
      '&vendor=' +
      encodeURIComponent(vendor);

    fetch(endpoint)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var profile = data && data.profile ? data.profile : null;
        if (!profile) return;

        var list = el.querySelector('[data-seller-legal-list]');
        var address = sellerProfileAddress(profile);
        var phone = sellerProfileValue(profile, ['Contact Number', 'contact', 'phone', 'phoneNumber']);
        var email = sellerProfileValue(profile, ['Contact Email', 'email', 'Email', 'Business Email']);
        var website = sellerProfileValue(profile, ['Website', 'website']);
        appendSellerLegalRow(list, '所在地', address);
        appendSellerLegalRow(list, '電話番号', phone);
        appendSellerLegalRow(list, 'メールアドレス', email);
        appendSellerLegalRow(list, 'ホームページ', website);

        var liquor = el.querySelector('[data-seller-liquor-info]');
        var liquorList = el.querySelector('[data-seller-liquor-list]');
        var liquorMissing = el.querySelector('[data-seller-liquor-missing]');
        var license = sellerProfileValue(profile, ['Liquor License', '酒類販売業免許', 'liquorLicense']);
        var licenseOffice = sellerProfileValue(profile, ['Licensing Authority', '免許者', 'licensingAuthority']);
        var manager = sellerProfileValue(profile, ['Liquor Sales Manager', '酒類販売管理者', 'liquorSalesManager']);
        var training = sellerProfileValue(profile, ['Manager Training Date', '研修受講年月日', 'managerTrainingDate']);
        if (license || licenseOffice || manager || training) {
          liquor.hidden = false;
          appendSellerLegalRow(liquorList, '酒類販売業免許', license);
          appendSellerLegalRow(liquorList, '免許者', licenseOffice);
          appendSellerLegalRow(liquorList, '酒類販売管理者', manager);
          appendSellerLegalRow(liquorList, '研修受講年月日', training);
        } else if (vendor === '株式会社ライドウィズ') {
          liquor.hidden = false;
          liquorMissing.hidden = false;
        }
      })
      .catch(function () {
        /* API unavailable: server-rendered販売業者名と各商品ページの情報を維持する */
      });
  });

  /* ---------- ベンダープロフィール紹介文（Puppet Vendors API） ---------- */
  /* コレクション(=ベンダープロフィール)ページで、Puppetのprofilesエンドポイントから
     「Additional Address」項目（企業の強み紹介文として転用）を取得して表示する。
     CORS開放のエンドポイントをクライアントサイドでfetch。プレーンテキストとして安全に描画。 */
  document.querySelectorAll('[data-vendor-profile]').forEach(function (el) {
    var vendor = (el.dataset.vendor || '').trim();
    var shop = el.dataset.shop;
    if (!vendor || !shop) return;
    var endpoint =
      'https://app.puppetvendors.com/webhooks/vendor/profiles?shop=' +
      encodeURIComponent(shop) +
      '&vendor=' +
      encodeURIComponent(vendor);
    fetch(endpoint)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.profile) return;
        var text = (data.profile['Additional Address'] || '').trim();
        if (!text) return;
        el.classList.add('rte');
        el.style.marginTop = (el.dataset.gapTop || 16) + 'px';
        el.style.marginBottom = (el.dataset.gapBottom || 32) + 'px';
        // 改行ごとに <p> を生成。textContentで入れるのでXSS安全。
        text.split(/\n+/).forEach(function (line) {
          if (!line.trim()) return;
          var p = document.createElement('p');
          p.textContent = line.trim();
          el.appendChild(p);
        });
      })
      .catch(function () {});
  });

  /* ---------- Puppet Vendors: 全ベンダー取得（共有キャッシュ） ---------- */
  /* vendorパラメータ無しで profiles を叩くと全ベンダーが配列で返る（CORS開放）。
     ページ内は Promise キャッシュ、ページ遷移をまたいでは sessionStorage（TTL 10分）で
     再取得を避ける。 */
  var PV_TTL = 10 * 60 * 1000;
  window.__pvVendorsCache = window.__pvVendorsCache || {};
  function getPuppetVendors(shop) {
    if (!shop) return Promise.resolve([]);
    if (window.__pvVendorsCache[shop]) return window.__pvVendorsCache[shop];

    var key = 'pv_vendors_' + shop;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key));
      if (cached && cached.t && Date.now() - cached.t < PV_TTL && Array.isArray(cached.d)) {
        var hit = Promise.resolve(cached.d);
        window.__pvVendorsCache[shop] = hit;
        return hit;
      }
    } catch (e) { /* sessionStorage不可でもfetchにフォールバック */ }

    var pr = fetch(
      'https://app.puppetvendors.com/webhooks/vendor/profiles?shop=' + encodeURIComponent(shop)
    )
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (list) {
        if (!Array.isArray(list)) list = [];
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: list })); } catch (e) {}
        return list;
      })
      .catch(function () { return []; });
    window.__pvVendorsCache[shop] = pr;
    return pr;
  }
  window.getPuppetVendors = getPuppetVendors;

  function pvCollectionUrl(name) {
    var key = (name || '').trim();
    if (window.pvCollUrls && window.pvCollUrls[key]) return window.pvCollUrls[key];
    return '/collections/vendors?q=' + encodeURIComponent(key);
  }

  /* ---------- 出店企業一覧（Puppet Vendors） ---------- */
  document.querySelectorAll('[data-seller-list]').forEach(function (listEl) {
    var section = listEl.closest('section') || listEl.parentElement;
    var tpl = section.querySelector('[data-seller-card]');
    var emptyEl = section.querySelector('[data-seller-empty]');
    var shop = listEl.dataset.shop;
    if (!tpl || !shop) return;
    var showLoc = listEl.dataset.showLocation === '1';
    var showDesc = listEl.dataset.showDescription === '1';

    getPuppetVendors(shop).then(function (vendors) {
      vendors.forEach(function (v) {
        var p = v.profile || {};
        var name = (v.vendorNameAlias || v.vendorName || p['Business Name'] || '').trim();
        if (!name) return;

        // 中身のある社のみ表示（ロゴ非プレースホルダー / バナー / 住所 / 紹介文 のいずれかが有る）
        var hasLogo = p.businessLogo && p.businessLogo.indexOf('placeholde') === -1;
        var hasBanner = p.profileBanner && p.profileBanner.indexOf('placeholde') === -1;
        var hasAddr = ((p.businessAddress && p.businessAddress.city) || '').trim();
        var hasDesc = (p.description || '').trim();
        if (!hasLogo && !hasBanner && !hasAddr && !hasDesc) return;

        var frag = tpl.content.cloneNode(true);
        var url = pvCollectionUrl(name);
        frag.querySelectorAll('[data-link]').forEach(function (a) { a.setAttribute('href', url); });

        var banner = frag.querySelector('[data-banner]');
        if (p.profileBanner && p.profileBanner.indexOf('placeholde') === -1) {
          banner.src = p.profileBanner;
          banner.alt = name;
          banner.hidden = false;
        }
        var logo = frag.querySelector('[data-logo]');
        if (p.businessLogo && p.businessLogo.indexOf('placeholde') === -1) {
          logo.src = p.businessLogo;
          logo.hidden = false;
        }
        frag.querySelector('[data-name]').textContent = name;

        if (showLoc) {
          var addr = ((p.businessAddress && p.businessAddress.city) || '').trim();
          if (addr) {
            frag.querySelector('[data-loc-text]').textContent = addr;
            frag.querySelector('[data-location]').hidden = false;
          }
        }
        if (showDesc) {
          var desc = (p.description || '').trim();
          if (desc) {
            var d = frag.querySelector('[data-desc]');
            d.textContent = desc;
            d.hidden = false;
          }
        }
        listEl.appendChild(frag);
      });
      if (!listEl.children.length && emptyEl) emptyEl.hidden = false;
    });
  });

  /* ---------- 商品カードの地域ラベル（Puppet Vendors） ---------- */
  /* 都道府県グループ→エリア色（色はインラインstyleで適用＝Tailwind purge回避） */
  var PV_AREA = [
    { prefs: ['北海道'], color: '#B9D5FF' },
    { prefs: ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県'], color: '#AEE9EE' },
    { prefs: ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '栃木県', '群馬県'], color: '#F9D5A2' },
    { prefs: ['新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県'], color: '#D6EFB1' },
    { prefs: ['三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県'], color: '#BBEAC4' },
    { prefs: ['鳥取県', '島根県', '岡山県', '広島県', '山口県'], color: '#F5C6B8' },
    { prefs: ['徳島県', '香川県', '愛媛県', '高知県'], color: '#D8C4F5' },
    { prefs: ['福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'], color: '#F6C9F3' }
  ];
  var PV_PREFS = [];
  PV_AREA.forEach(function (a) { a.prefs.forEach(function (p) { PV_PREFS.push(p); }); });

  function pvRegion(addr) {
    addr = (addr || '').trim();
    var pref = null;
    for (var i = 0; i < PV_PREFS.length; i++) {
      if (addr.indexOf(PV_PREFS[i]) === 0) { pref = PV_PREFS[i]; break; }
    }
    if (!pref) return null;
    var rest = addr.slice(pref.length);
    var m = rest.match(/^[^0-9０-９]*?[市区町村郡]/);
    var color = '#ffd89b';
    for (var j = 0; j < PV_AREA.length; j++) {
      if (PV_AREA[j].prefs.indexOf(pref) >= 0) { color = PV_AREA[j].color; break; }
    }
    return { label: pref + (m ? m[0] : ''), color: color };
  }

  (function () {
    var locEls = document.querySelectorAll('[data-vendor-location]');
    var shop = window.Shopify && window.Shopify.shop;
    if (!locEls.length || !shop) return;
    getPuppetVendors(shop).then(function (vendors) {
      var byName = {};
      vendors.forEach(function (v) {
        var p = v.profile || {};
        var addr = (p.businessAddress && p.businessAddress.city) || '';
        if (!addr) return;
        [v.vendorName, v.vendorNameAlias, p['Business Name']].forEach(function (k) {
          if (k) byName[k.trim().toLowerCase()] = addr;
        });
      });
      locEls.forEach(function (el) {
        var vname = (el.dataset.vendor || '').trim().toLowerCase();
        var r = pvRegion(byName[vname]);
        if (!r) return;
        el.textContent = r.label;
        el.style.backgroundColor = r.color;
        el.classList.remove('hidden');
      });
    });
  })();

  /* ---------- 出店企業マップ（Puppet Vendors） ---------- */
  function loadScript(src, cb) {
    if (!src) { if (cb) cb(); return; }
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    if (cb) s.onload = cb;
    document.head.appendChild(s);
  }

  document.querySelectorAll('[data-collection-map]').forEach(function (mapEl) {
    var sectionId = mapEl.dataset.sectionId;
    var apiKey = mapEl.dataset.apiKey;
    var shop = mapEl.dataset.shop;
    if (!apiKey || !shop || !sectionId) return;

    getPuppetVendors(shop).then(function (vendors) {
      var parts = [];
      vendors.forEach(function (v) {
        var p = v.profile || {};
        var name = (v.vendorNameAlias || v.vendorName || '').trim();
        var addr = ((p.businessAddress && p.businessAddress.city) || '').trim();
        if (!name || !addr) return; // 住所未入力は地図に出せない
        var url = pvCollectionUrl(name);
        // collection-map.js のマーカー形式: id|title|company|address|url
        parts.push([v.vendorNameAlias || name, name, name, addr, url].join('|'));
      });
      if (!parts.length) return;

      window.collectionMapData = window.collectionMapData || {};
      window.collectionMapData[sectionId] = {
        markers: parts.join('|||'),
        apiKey: apiKey,
        defaultZoom: parseInt(mapEl.dataset.zoom, 10) || 6,
        defaultCenter: {
          lat: parseFloat(mapEl.dataset.lat) || 36.2048,
          lng: parseFloat(mapEl.dataset.lng) || 138.2529
        }
      };
      window.initCollectionMap = function () {
        if (typeof window.initializeCollectionMap === 'function') window.initializeCollectionMap();
      };
      // collection-map.js を読み込んでから Google Maps を読み込む（コールバック時に描画関数が存在するように）
      loadScript(mapEl.dataset.mapJs, function () {
        loadScript(
          'https://maps.googleapis.com/maps/api/js?key=' +
            encodeURIComponent(apiKey) +
            '&callback=initCollectionMap&libraries=places'
        );
      });
    });
  });

  /* ---------- 関連商品（Recommendations API） ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var url = el.dataset.url;
    if (!url || el.children.length > 0) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.children.length > 0) el.innerHTML = fresh.innerHTML;
      });
  });
})();
